import React from 'react';
import NoEscape from '../../../../Components/NoEscape';

interface Props {
	text: string;
}

const EscapeWithLines: React.FC<Props> = ({ text }) => {
	const parsed = text.replace(/&quot;/g, '"').replace(/\n/g, '<br />');
	return <NoEscape>{parsed}</NoEscape>;
};

export default EscapeWithLines;
